export const SET_ASSIGNMENT = 'SET_ASSIGNMENT'
export const SET_REPORT = 'SET_REPORT'
export const CLEAR_REPORT = 'CLEAR_REPORT'
export const SET_REDO = 'SET_REDO'
